import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import useCoapplicantStore from '../../../store/coapplicantStore/useCoapplicantStore';
import useDashboardStore from '../../../store/dashboardStore/useDashboardStore';
import { locator } from '../../../testing/e2e-locator/locator';

const CoapplicantPersonalSection = (): ReactNode => {
  const { t } = useTranslation();
  const {
    computed: { vehicleId },
  } = useDashboardStore();

  const {
    coapplicantFirstName,
    coapplicantLastName,
    coapplicantPrimaryPhoneNumber,
    coapplicantPrimaryEmailAddress,
  } = useCoapplicantStore();

  return (
    <span data-testid={locator.components.coapplicantPersonalSection.root}>
      <div className="head">
        <h3 data-testid={locator.components.coapplicantPersonalSection.h3}>
          {t('CoapplicantReviewPage.personal')}
        </h3>
        <Link
          data-testid={locator.components.coapplicantPersonalSection.editLink}
          to={`/applicant/${vehicleId}/coapp-edit-personal`}
        >
          {t('CoapplicantReviewPage.edit')}
        </Link>
      </div>

      <ul>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.firstName')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantPersonalSection.firstName
              }
            >
              {coapplicantFirstName || '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.lastName')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantPersonalSection.lastName
              }
            >
              {coapplicantLastName || '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.phone')}</dt>
            <dd
              data-testid={
                locator.components.coapplicantPersonalSection.phoneNumber
              }
            >
              {coapplicantPrimaryPhoneNumber
                ? coapplicantPrimaryPhoneNumber.replace(
                    /(\d{3})(\d{3})(\d{4})/,
                    '($1) $2-$3',
                  )
                : '-'}
            </dd>
          </dl>
        </li>
        <li>
          <dl>
            <dt>{t('CoapplicantReviewPage.email')}</dt>
            <dd
              data-testid={locator.components.coapplicantPersonalSection.email}
            >
              {coapplicantPrimaryEmailAddress || '-'}
            </dd>
          </dl>
        </li>
      </ul>
    </span>
  );
};

export default CoapplicantPersonalSection;
